import { AxiosError, InternalAxiosRequestConfig } from "axios";
import { useRouteError } from "react-router-dom";

const RouteError = () => {
  const error = useRouteError();
  let message = undefined
  let stack = undefined
  let config: InternalAxiosRequestConfig<any> | undefined;

  if(error instanceof Error){
    message = error.message;
    stack = error.stack;
  } else {
    message = error as string;
  }

  if(error instanceof AxiosError) {
    message = error.message
    config = error.config;
  }
  console.error(error)

  return (
    <div className="bg-red-100 m-3 px-2 py-4 font-semibold text-red-700 rounded-md border border-red-700">
      <h1 className="text-lg">Ops something went wrong: {message}</h1>
      <p>Api Route: {config?.url}</p>
      <pre>
        {stack}
      </pre>
    </div>
  );
};

export default RouteError;
